// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/css/list.css
 ** module id = 5
 ** module chunks = 0
 **/